import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { ListsState } from '../reducers/lists.reducer';
import * as selectors from '../selectors/lists.selectors';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ListsFacadeService extends FacadeService {
  constructor(public override store: Store<ListsState>) {
    super(store);
  }

  // OBSERVABLES

  panelExpandedValue$ = this.storeSelect(selectors.getPanelExpansion);
  name$ = this.storeSelect(selectors.getName);
  description$ = this.storeSelect(selectors.getDescription);
  target$ = this.storeSelect(selectors.getTarget);
  targets$ = this.storeSelect(selectors.getTargets);
  targetsValuesWithLiterals$ = this.storeSelect(selectors.getTargetsValuesWithLiterals);

  // OBSERVABLE'S VALUES

  get panelExpandedValue() {
    return this.storeSnapshot(this.panelExpandedValue$);
  }

  get name() {
    return this.storeSnapshot(this.name$);
  }

  get description() {
    return this.storeSnapshot(this.description$);
  }

  get target() {
    return this.storeSnapshot(this.target$);
  }

  get targetsValuesWithLiterals() {
    return this.storeSnapshot(this.targetsValuesWithLiterals$);
  }
}
